<template>
  <Select
    v-if="availableRollouts.length"
    v-model="selectedRollout"
    :options="availableRollouts"
    :clearable="false"
    button-id="rollout-selection"
    keyboard-shortcut="/"
  >
    <template v-if="isStaff" #prefix="{ element }: { element: Rollout }">
      <span
        :class="[
          'mr-3 inline-block size-2 shrink-0 rounded-full',
          getStatusColor(element),
        ]"
        aria-hidden="true"
      />
    </template>
  </Select>
</template>

<script lang="ts" setup>
import { useUserStore } from '~~/stores/user';
import type { Rollout } from '@/types';
import { UserRole } from '@/config/user-roles';

const { selectedRollout: _selectedRollout } = useRolloutRouting();
const selectedRollout = computed({
  get: () => _selectedRollout.value || {},
  set: (value: Rollout) => {
    _selectedRollout.value = value;
  },
});

const userStore = useUserStore();
const availableRollouts = computed(() => userStore.availableRollouts);

const isStaff = computed(
  () => userStore.user && userStore.user.role >= UserRole.SERVICE_DESK
);

const getStatusColor = (rollout: Rollout) => {
  if (rollout.totalClients) {
    if (rollout.totalClients === rollout.clientsDone) {
      // Done
      return 'bg-green-400';
    }

    // In progress
    return 'bg-yellow-300';
  }

  // Not started
  return 'bg-gray-200';
};
</script>
